
const CONEKTA = 'conekta',
  CONEKTA_GLOBAL = 'conekta global',
  CONTPAQI = 'contpaqi',
  OXXO = 'oxxo',
  SAT = 'sat',
  SAT_DOWNLOADS = 'sat_downloads',
  SPEI = 'spei',
  STRIPE = 'stripe',
  FISERV = 'fiserv',
  MINIMUM_AMOUNT_TO_PAY = 15,
  MAXIMUN_AMOUNT_TO_PAY_OXXO = 10000,
  MINIMUM_AMOUNT_TO_PAY_CONEKTA_GLOBAL = 20,
  INTEGRATION_IS_ACTIVE = 'active',
  INTEGRATION_IS_INACTIVE = 'inactive',
  INTEGRATION_IS_ENABLE = 1,
  PAYMENT_INSTRUCTIONS_ID = 2,
  CONEKTA_INTEGRATION_ID = 5,
  OXXO_INTEGRATION_ID = 6;

export {
  CONEKTA,
  CONEKTA_GLOBAL,
  CONTPAQI,
  OXXO,
  SAT,
  SAT_DOWNLOADS,
  SPEI,
  STRIPE,
  FISERV,
  MINIMUM_AMOUNT_TO_PAY,
  MAXIMUN_AMOUNT_TO_PAY_OXXO,
  MINIMUM_AMOUNT_TO_PAY_CONEKTA_GLOBAL,
  INTEGRATION_IS_ACTIVE,
  INTEGRATION_IS_INACTIVE,
  INTEGRATION_IS_ENABLE,
  CONEKTA_INTEGRATION_ID,
  OXXO_INTEGRATION_ID,
  PAYMENT_INSTRUCTIONS_ID
};



// WEBPACK FOOTER //
// ./src/constants/integrations.js